import { render } from "./SimpleSelect2.vue?vue&type=template&id=993b8660"
import script from "./SimpleSelect2.vue?vue&type=script&lang=js"
export * from "./SimpleSelect2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__